import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _includes from 'lodash/includes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ChatBot from '../../contactUs/components/ChatBot';
import ArticlePanel from './ArticlePanel';
import { loadModalContainer } from '../../contactUs/actions/action-login-modal';
import { chatBotClickedAction } from '../../contactUs/actions/action-chat-bot';
import Page from '../../lib/page';

const isLoggedIn = Page.isLoggedIn();
const isArticleChatBotEligible = Page.getIsArticleChatBotEligible(); // pxp exp
const articlesForChatBot = Page.getArticlesForChatBot(); // remote config check for articles to enable chatbot
const articleFaqId = Page.getArticleIdLowerCase();
const chatBotPostServiceEnabled = Page.isChatBotPostServiceEnabled();

class ArticleChatBotContainer extends Component {
  constructor(props) {
    super(props);
    this.chatBotClicked = this.chatBotClicked.bind(this);
  }

  chatBotClicked() {
    // Let's open up the login modal.
    if (!isLoggedIn) {
      this.props.chatBotClickedAction();
      sessionStorage.setItem('articlePagechatBotClicked', 'true');
      return this.props.loadModalContainer('chatBot');
    }
    return null;
  }

  render() {
    const wasChaBotClicked = (sessionStorage && sessionStorage.getItem('chatBotClicked') === 'true');
    const { chatBotDisplay } = this.props;
    let display = false;
    /**
     * Checking if isChatBotPostServiceEnabled Remote config is enabled
     * if Enabled display the chatbot based on post chatbot eligibility API response
     * else display the chatbot based on existing RC & PXP
     */
    if (chatBotPostServiceEnabled) {
      display = chatBotDisplay;
    } else {
      display = (!isLoggedIn || (isLoggedIn && wasChaBotClicked)) && isArticleChatBotEligible && _includes(articlesForChatBot, articleFaqId);
    }
    if (!display) {
      return (<ArticlePanel />);
    }
    return (
      <div>
        <ArticlePanel />
        <ChatBot
          link="smarthelp-chat-bot-article" id="chatBotArticle" topicRefId="GENPOOL|articlePage" hpid={articleFaqId} display={display} chatBotClicked={this.chatBotClicked}
        />
      </div>);
  }
}

ArticleChatBotContainer.propTypes = {
  loadModalContainer: PropTypes.func.isRequired,
  chatBotClickedAction: PropTypes.func,
  chatBotDisplay: PropTypes.string.isRequired,
};

ArticleChatBotContainer.defaultProps = {
  chatBotClickedAction: () => {},
  postChatBotEligibility: () => {},
};

// Get the postChatBotEligibility redux data and Pass it as Props.
function mapStateToProps(state) {
  return {
    chatBotDisplay: state.postChatBotEligibility.chatBotDisplay,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ loadModalContainer, chatBotClickedAction }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleChatBotContainer);
